import React from "react";
import Footer from "./Footer";
import TopBar from "./TopBar";
import { Box, styled } from "@mui/material";
import { useLocation } from "react-router-dom";

const Root = styled(Box)(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  "& .leftShade2": {
    position: "relative",
    zIndex: 999,
    boxShadow: "39px -9px 60px 49px #000000",
  },
}));

const MainContainer = styled(Box)(() => ({
  minHeight: "calc(100vh - 415px)",
}));

const MainLayout = ({ children }) => {
  const location = useLocation();

  return (
    <Root>
      <Box className="loginRightSahdowdash"></Box>
      <TopBar />
      {location?.pathname !== "/" && <Box></Box>}
      <MainContainer>{children}</MainContainer>
      <Footer />
    </Root>
  );
};

export default MainLayout;
